module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs is-large"
  }, [_c('ul', [_c('li', {
    class: [{
      'is-active': this.name == 'overview'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/overview'
    }
  }, [_vm._v("Overview")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'points'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/points'
    }
  }, [_vm._v("Points")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'plus-minus'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/plus-minus'
    }
  }, [_vm._v("Plus / Minus")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'penalty-minutes'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/penalty-minutes'
    }
  }, [_vm._v("Penalty Minutes")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'shots'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/shots'
    }
  }, [_vm._v("Shots")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'shot-differentials'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/shot-differentials'
    }
  }, [_vm._v("Shot Differentials")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'faceoffs'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/faceoffs'
    }
  }, [_vm._v("Faceoffs")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'turnovers'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/turnovers'
    }
  }, [_vm._v("Turnovers")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'hits'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/hits'
    }
  }, [_vm._v("Hits")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'time-on-ice'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/time-on-ice'
    }
  }, [_vm._v("Time On Ice")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'zone-entries'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/zone-entries'
    }
  }, [_vm._v("Zone Entries / Exits")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'zone-starts'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/zone-starts'
    }
  }, [_vm._v("Zone Starts")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'raw-data'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/raw-data'
    }
  }, [_vm._v("Raw Data")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'per-sixty'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/per-sixty'
    }
  }, [_vm._v("Per Sixty Comparison Tool")])], 1), _vm._v(" "), _c('li', {
    class: [{
      'is-active': this.name == 'vs-team'
    }]
  }, [_c('router-link', {
    attrs: {
      "to": '../../season-stats/vs-team'
    }
  }, [_vm._v("VS Team")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-397eaf63"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/season-totals-menu.vue
// module id = 606
// module chunks = 30